import Immutable from 'immutable';
import {handleActions} from 'redux-actions';

const defaultState = Immutable.fromJS({
  message: null
})

export default handleActions({
  SET_MESSAGE: (state, action) => {
    return state.merge(action.payload).merge({time: new Date()})
  }
}, defaultState)
